/* eslint-disable lingui/no-unlocalized-strings -- Browser event identifiers. */
import { useEffect } from "react";

import { onConsentChange } from "@/client/analytics/consent";
import { syncAnalyticsContext } from "@/client/analytics/context";
import { useAuthStore } from "@/client/stores/auth";

// GA starts a new session after 30 minutes idle, so a returning tab refreshes the stored session.
const REFRESH_AFTER_MS = 10 * 60 * 1000;

/**
 * Persist acquisition and the current GA browser/session after authentication: once per sign-in,
 * when gtag finishes loading, on a cookie-choice change, and when a tab returns after a while.
 * Checkout and complete-profile also sync right before they need it, so route changes do not.
 */
export const Ga4ContextSync = () => {
  const userId = useAuthStore((state) => state.user?.id);
  useEffect(() => {
    if (!userId) return;
    let lastSync = 0;
    const sync = () => {
      lastSync = Date.now();
      void syncAnalyticsContext();
    };
    const visible = () => {
      if (document.visibilityState === "visible" && Date.now() - lastSync > REFRESH_AFTER_MS) {
        sync();
      }
    };
    sync();
    const unsubscribe = onConsentChange(sync);
    document.addEventListener("visibilitychange", visible);
    window.addEventListener("ga4:ready", sync);
    return () => {
      unsubscribe();
      document.removeEventListener("visibilitychange", visible);
      window.removeEventListener("ga4:ready", sync);
    };
  }, [userId]);
  return null;
};
